





























































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import Layout from "@/components/Layout.vue";
import Button from "@/form/Button.vue";
import CompanyDetails from "@/components/CompanyDetails.vue";
import PageHeader from "@/components/PageHeader.vue";
import ModalWithSaveAndCancel from "@/components/ModalWithSaveAndCancel.vue";
import CompanyConfigDetails from "@/components/CompanyConfigDetails.vue";
import UserDetails from "@/components/UserDetails.vue";
import {
	Field,
	HierarchiesToAccess,
	RoleOption,
} from "@/pages/maintenanceTypes";
import axios from "@/utils/ApiUtils";
import {
	portalRolesForAddUser,
	portalRolesListURL,
	portalSponsorsListURL,
	portalUserURL,
	currentBrandsListURL,
} from "@/constants/apiconstants";
import SubHeading from "@/components/SubHeading.vue";
import CheckBoxGroup from "@/form/CheckBoxGroup.vue";
import { createNamespacedHelpers } from "vuex";
import { EmployerHierarchy } from "@/store/modules/persistent/persistentTypes";
import Grid from "@/grid/Grid.vue";
import { EMPLOYER, hasPermission, PARENT, RC } from "@/utils/PermissionUtils";
import { toastErrorMessage, toastSuccessMessage } from "@/plugins/toasts";
import { parseErrorMessage } from "@/utils/ErrorUtils";
import { VForm } from "@/@typings/type-vee-validate";
import { AppRoute, AppRouteNextFunction } from "@/router";
import { PortalUser } from "@/models/PortalUser";
import { CheckBoxGroupOption, SelectOption } from "@/form/FieldOptions";
import {
	isDomainUser,
	isSponsorUser,
} from "@/pages/maintenance/PortalUserUtils";
import SelectField from "@/form/SelectField.vue";
import {
	ColDef,
	ColGroupDef,
	ICellRendererParams,
	ValueGetterParamsTyped,
} from "ag-grid-community";
import CheckBoxRenderer from "@/grid/cellrenderers/CheckBoxRenderer.vue";
import { filter, findIndex, forEach, uniq } from "lodash";

/**
 * This should correspond to the Java class au.com.iress.clearinghouse.portal.user.UserRestService.UserResponse
 */
interface UserResponse {
	user: PortalUser;
	roles: RoleOption[];
	employerTreeHierarchy: EmployerHierarchy[];
	userRoleIds: number[];
	entities: string[];
	canEditRoles: boolean;
	userSponsorIds: number[];
	sponsors: CheckBoxGroupOption[];
}

interface CheckBoxGroupOptionBrand extends CheckBoxGroupOption {
	brandId: number;
}

type PageMode = "add" | "edit" | "view";

// Edit user roles
const EDIT_USERS = "EDIT_USERS";
const EDIT_DOMAIN_USERS = "EDIT_DOMAIN_USERS";
const EDIT_SPONSOR_USERS = "EDIT_SPONSOR_USERS";

async function getPortalUser(userId: number) {
	return axios
		.get<UserResponse>(portalUserURL(userId))
		.then((response) => response.data);
}

async function getPortalUserRoles() {
	return axios
		.get<{ roles: RoleOption[] }>(portalRolesForAddUser())
		.then((response) => response.data);
}

async function getPortalUserRolesForView() {
	return axios
		.get<{ roles: RoleOption[] }>(portalRolesListURL())
		.then((response) => response.data);
}

async function getSponsors() {
	return axios
		.get<CheckBoxGroupOptionBrand[]>(portalSponsorsListURL())
		.then((response) => response.data);
}

interface BrandOption {
	value: number;
	label: string;
	code: string;
}
interface BrandList {
	brands: BrandOption[];
}
function hasEditPermissionOnUser(user: PortalUser) {
	if (isDomainUser(user)) {
		return hasPermission(EDIT_DOMAIN_USERS);
	} else if (isSponsorUser(user)) {
		return hasPermission(EDIT_SPONSOR_USERS);
	} else {
		return hasPermission(EDIT_USERS);
	}
}

function getModeFromPath(path: string): PageMode {
	const parts = path.split("/");
	if (parts.length < 3) {
		throw new Error(`Invalid path for user page: ${path}`);
	}
	return parts[2] as PageMode;
}

const { mapState } = createNamespacedHelpers("persistent");
const noParentEmployerPrefix = "P_O_";
@Component({
	components: {
		SelectField,
		SubHeading,
		UserDetails,
		CompanyConfigDetails,
		PageHeader,
		CompanyDetails,
		ModalWithSaveAndCancel,
		Layout,
		Button,
		CheckBoxGroup,
		Grid,
	},
	computed: mapState([
		"selectedEntities",
		"employerHierarchy",
		"brandId",
		"roles",
	]),
})
export default class AddOrEditPortalUsers extends Vue {
	/**
	 * Type the mapped persistent.employerHierarchy getter.
	 * It is a computed property. Do not mutate it.
	 */
	employerHierarchy!: EmployerHierarchy[];

	/**
	 * Type the mapped persistent.selectedEntities getter.
	 * It is a computed property. Do not mutate it.
	 * hide brandList component if its
	 */
	brandId!: number | null;

	/**
	 * Type the mapped persistent.roles getter.
	 * It is a computed property. Do not mutate it.
	 * Roles of the current user
	 */
	roles!: string[];

	public $refs!: {
		gridEl: Grid;
		userDetailsForm: VForm;
	};
	private showCancelModal = false;
	private isFormDirty = false;

	private pageMode: PageMode = "add";

	/**
	 * - Empty object in add user page.
	 * - Initialised in beforeRouterEnter in edit/view user page.
	 */
	private userDetail: PortalUser = {
		id: 0,
		title: null,
		name: "",
		position: null,
		email: "",
		mobilePhone: null,
		lastLogin: null,
		suspend: false,
		ownRecord: false,
		admin: false,
		brandId: null,
		sponsorId: null,
		domainId: null,
	};

	private canEditRoles: boolean = this.pageMode !== "view";
	// Role selected can either show or hide Sponsors
	private showSponsors = false;

	private roleOptions: RoleOption[] = [];
	private sponsorOptions: CheckBoxGroupOptionBrand[] = [];
	private brandOptions: SelectOption[] = [];
	// keeps track of selected entities
	private applyRolesToEntities: string[] = [];
	private hierarchiesToAccess: HierarchiesToAccess[] = [];
	private parentChildRelationship: { [key: string]: string[] } = {};
	private childParentRelationship: { [key: string]: string } = {};

	private userRoleIds: number[] = [];
	private userSponsorIds: number[] = [];

	private orphanParent = true;

	private columnDefs: (ColGroupDef | ColDef)[] = [
		{
			field: "parentLabel",
			hide: true,
			rowGroup: true,
		},
		{
			field: "employerLabel",
			hide: true,
			rowGroup: true,
		},
		{
			headerName: "Reporting centre",
			field: "rcLabel",
			minWidth: 300,
			resizable: true,
			menuTabs: ["filterMenuTab"],
			filter: true,
			filterParams: {
				buttons: ["reset"],
				applyMiniFilterWhileTyping: true,
			},
		},
		{
			headerName: "Apply selection roles",
			minWidth: 20,
			resizable: true,
			cellRenderer: this.checkBoxRender,
		},
	];

	private autoGroupColumnDef = {
		minWidth: 200,
		menuTabs: ["filterMenuTab"],
		filter: true,
		filterParams: {
			buttons: ["reset"],
			applyMiniFilterWhileTyping: true,
		},
		filterValueGetter: (
			params: ValueGetterParamsTyped<HierarchiesToAccess>
		) =>
			params.data[
				params.colDef.showRowGroup as keyof HierarchiesToAccess
			],
	};

	private gridVMList: Vue[] = [];
	private disableAllCheckboxes = false;
	private disableGridCheckboxes = false;

	checkBoxRender(params: ICellRendererParams): HTMLElement {
		const vm = new Vue({
			el: document.createElement("div"),
			render: (createElement) => {
				return createElement(CheckBoxRenderer, {
					props: {
						rowIndex: params.rowIndex,
						groupBy: this.getGroupBy(params),
						row: this.getData(params),
						// Note (York): To who are confused about checkbox in the grid cell.
						// `setCheckBoxValue` includes `applyRolesToEntities` in its closure. When
						// `applyRolesToEntities` is changed, i.e, onClickCheckBox -> addOrRemoveEntity,
						// then all checkBoxRender(s) re-render.
						// I don't know if it is good design.
						value: this.setCheckBoxValue(params),
						disable: this.disableGridCheckboxes,
					},
					on: {
						input: this.onClickCheckBox,
					},
				});
			},
		});
		this.gridVMList.push(vm);
		return vm.$el as HTMLElement;
	}

	getGroupBy(params: ICellRendererParams) {
		if (params.node.level === 0 && !this.orphanParent) {
			return PARENT;
		} else if (
			(params.node.level === 1 && !this.orphanParent) ||
			(params.node.level === 0 && this.orphanParent)
		) {
			return EMPLOYER;
		} else {
			return RC;
		}
	}

	// update it via events to avoid data mutation from user-details component
	updateUserDetail(e: { field: Field; value: string }) {
		if (this.userDetail) {
			Vue.set(this.userDetail, e.field, e.value);
			this.isFormDirty = true;
		}
	}

	// gets node data for grouped rows which are computed
	getData(params: ICellRendererParams) {
		if (params.data) {
			return params.data;
		}
		// employer
		else if (
			params.node?.childrenAfterFilter != null &&
			params.node?.childrenAfterFilter[0]?.data
		) {
			return {
				parentId: params.node.childrenAfterFilter[0]?.data.parentId,
				parentLabel:
					params.node.childrenAfterFilter[0]?.data.parentLabel,
				employerLabel:
					params.node.childrenAfterFilter[0]?.data.employerLabel,
				employerId: params.node.childrenAfterFilter[0]?.data.employerId,
			};
		}
		// parent
		else if (
			params.node?.childrenAfterFilter != null &&
			params.node?.childrenAfterFilter[0]?.childrenAfterFilter != null &&
			params.node?.childrenAfterFilter[0]?.childrenAfterFilter[0].data
		) {
			return {
				parentId:
					params.node.childrenAfterFilter[0].childrenAfterFilter[0]
						.data.parentId,
				parentLabel:
					params.node.childrenAfterFilter[0].childrenAfterFilter[0]
						.data.parentLabel,
			};
		}

		return null;
	}

	getSponsorBrandOptions() {
		const selectedSponsorBrands = this.sponsorOptions
			.filter((s) => this.userSponsorIds.includes(parseInt(s.value)))
			.map((s) => s.brandId);
		return this.brandOptions.filter((b) =>
			selectedSponsorBrands.includes(parseInt(b.value))
		);
	}

	setCheckBoxValue(params: ICellRendererParams) {
		const data: HierarchiesToAccess | null = this.getData(params);
		if (!data) {
			return false;
		}
		// rc
		if (data.rcId) {
			if (
				(data.rcId &&
					this.applyRolesToEntities.indexOf(data.rcId) > -1) ||
				(data.employerId &&
					this.applyRolesToEntities.indexOf(data.employerId) > -1) ||
				this.applyRolesToEntities.indexOf(data.parentId) > -1
			) {
				return true;
			}
		} // employer
		else if (data.employerId) {
			if (
				(data.employerId &&
					this.applyRolesToEntities.indexOf(data.employerId) > -1) ||
				this.applyRolesToEntities.indexOf(data.parentId) > -1
			) {
				return true;
			}
		} // parent
		else if (
			data.parentId &&
			params.node.childrenAfterGroup &&
			params.node.childrenAfterGroup[0].childrenAfterGroup
		) {
			const data: HierarchiesToAccess =
				params.node.childrenAfterGroup[0].childrenAfterGroup[0].data;
			if (
				data.parentId &&
				this.applyRolesToEntities.indexOf(data.parentId) > -1
			) {
				return true;
			}
		}

		return false;
	}

	// typically it has to be of type HierarchiesToAccess
	addOrRemoveEntity(data: any, key: string, checkBoxValue: boolean) {
		if (!checkBoxValue) {
			if (key === "employerId") {
				// check if parent is checked
				this.removeParent(data);
			} else if (key === "rcId") {
				this.removeParentAndEmployer(data);
			} else {
				const parentIdx = findIndex(
					this.applyRolesToEntities,
					(entity) => {
						return entity === data[key];
					}
				);
				this.applyRolesToEntities.splice(parentIdx, 1);
			}
		} else {
			// find entity
			const keyIdx = findIndex(this.applyRolesToEntities, (entity) => {
				return entity === data[key];
			});

			// add if not found
			if (data[key] && keyIdx === -1 && checkBoxValue) {
				this.applyRolesToEntities.push(data[key]);
			}
		}

		// remove all children if parent is set
		this.applyRolesToEntities = filter(
			this.applyRolesToEntities,
			(entityId) => {
				if (
					this.childParentRelationship[entityId] &&
					this.childParentRelationship[entityId].startsWith(
						EMPLOYER
					) &&
					this.childParentRelationship[
						this.childParentRelationship[entityId]
					] &&
					this.applyRolesToEntities.indexOf(
						this.childParentRelationship[
							this.childParentRelationship[entityId]
						]
					) > -1
				) {
					return false;
				} else if (
					!(
						this.childParentRelationship[entityId] &&
						this.applyRolesToEntities.indexOf(
							this.childParentRelationship[entityId]
						) > -1
					)
				) {
					return true;
				} else return false;
			}
		);
		this.applyRolesToEntities = uniq(this.applyRolesToEntities);
	}

	removeParent(data: HierarchiesToAccess) {
		const keyIdx = findIndex(this.applyRolesToEntities, (entity) => {
			return entity === data.parentId;
		});

		if (keyIdx > -1) {
			// remove parent
			this.applyRolesToEntities.splice(keyIdx, 1);

			// add children except current entity
			const childrenToAdd: string[] = filter(
				this.parentChildRelationship[data.parentId],
				(entityId) => {
					return entityId !== data.employerId;
				}
			);

			this.applyRolesToEntities = [
				...this.applyRolesToEntities,
				...childrenToAdd,
			];
		}
		// remove a single element  i.e. employer
		else {
			const employerId = findIndex(
				this.applyRolesToEntities,
				(entity) => {
					return entity === data.employerId;
				}
			);

			this.applyRolesToEntities.splice(employerId, 1);
		}
	}

	removeParentAndEmployer(data: HierarchiesToAccess) {
		const keyIdx = findIndex(this.applyRolesToEntities, (entity) => {
			return entity === data.employerId || entity === data.parentId;
		});
		const parentSelected = this.applyRolesToEntities.includes(
			data.parentId
		);
		const standAloneEmployer = data.parentId.startsWith(
			noParentEmployerPrefix
		);
		if (keyIdx > -1 && data.employerId) {
			// remove parent
			this.applyRolesToEntities.splice(keyIdx, 1);
			// employers to add
			// add children except current entity
			const employersToAdd: string[] = filter(
				this.parentChildRelationship[data.parentId],
				(entityId) => {
					return (
						entityId !== data.employerId &&
						(standAloneEmployer || parentSelected || !data.rcId)
					);
				}
			);

			// add children except current rcId
			const childrenToAdd: string[] = filter(
				this.parentChildRelationship[data.employerId],
				(entityId) => {
					return entityId !== data.rcId;
				}
			);
			this.applyRolesToEntities = [
				...this.applyRolesToEntities,
				...employersToAdd,
				...childrenToAdd,
			];

			// remove RC
			if (this.orphanParent) {
				const rcIdx = findIndex(this.applyRolesToEntities, (entity) => {
					return entity === data.rcId;
				});

				this.applyRolesToEntities.splice(rcIdx, 1);
			}
		}
		// remove a single element  i.e. rc
		else {
			const rcIdx = findIndex(this.applyRolesToEntities, (entity) => {
				return entity === data.rcId;
			});

			this.applyRolesToEntities.splice(rcIdx, 1);
		}
	}

	roleOption(value: number) {
		return this.roleOptions.find((ro) => Number(ro.value) === value);
	}

	updateUserRole(value: number[]) {
		this.userRoleIds = value;

		// This handles the roleExclusive logic by comparing the previously selected role with new role selected
		const previouslySelected =
			value.length > 1 ? value[value.length - 2] : null;
		let previouslySelectedRole;
		if (previouslySelected) {
			previouslySelectedRole = this.roleOption(previouslySelected);
		}

		const recentlySelected =
			value.length > 0 ? value[value.length - 1] : null;

		let recentlySelectedRole;
		if (recentlySelected) {
			recentlySelectedRole = this.roleOption(recentlySelected);
		}

		if (recentlySelectedRole === previouslySelectedRole) {
			this.userRoleIds = [];
			this.updateRoles();
			this.showSponsors = false;
			this.isFormDirty = true;
			return;
		}

		if (recentlySelectedRole && previouslySelectedRole) {
			// Check for role exclusivity
			if (
				recentlySelectedRole.roleExclusive ||
				(!recentlySelectedRole.roleExclusive &&
					previouslySelectedRole.roleExclusive) ||
				recentlySelectedRole.category !==
					previouslySelectedRole.category
			) {
				this.userRoleIds = [];
				this.userRoleIds.push(Number(recentlySelected));
			}
		}

		const mainRole = this.roleOption(this.userRoleIds[0]);
		this.showSponsors = mainRole?.showSponsors ?? false;

		this.updateRoles();
		this.isFormDirty = true;
	}

	updateRoles() {
		if (this.userRoleIds.length >= 1) {
			this.singleRole();
		} else if (this.userRoleIds.length === 0) {
			this.noRole();
		}
	}

	updateSponsorIds(value: number[]) {
		this.userSponsorIds = value;
		this.isFormDirty = true;
	}

	created() {
		this.buildHierarchiesToAccess();
		if (this.orphanParent) {
			this.columnDefs.shift();
		}
		this.pageMode = getModeFromPath(this.$route.path);

		if (this.pageMode === "edit" || this.pageMode === "view") {
			// Need to load the roles in this way so the checkbox doesn't think there is a change.
			// Load value first, then load options. The role group check box renders once there are options.
			const userId = Number(this.$route.params.userId);
			getPortalUser(userId)
				.then((userResponse) => {
					this.userDetail = userResponse.user;
					if (userResponse.userRoleIds) {
						this.userRoleIds = userResponse.userRoleIds;
						this.applyRolesToEntities = userResponse.entities;
					}
					if (userResponse.userSponsorIds) {
						this.userSponsorIds = userResponse.userSponsorIds;
					}
				})
				.then(() => {
					if (this.pageMode === "edit") {
						getPortalUserRoles()
							.then((roleResponse) => {
								this.roleOptions = roleResponse.roles;
								this.updateRoles();
							})
							.catch((error) =>
								toastErrorMessage(parseErrorMessage(error))
							);
					} else {
						getPortalUserRolesForView()
							.then((roleResponse) => {
								this.roleOptions = roleResponse.roles;
								this.updateRoles();
							})
							.catch((error) =>
								toastErrorMessage(parseErrorMessage(error))
							);
					}
				})
				.catch((error) => toastErrorMessage(parseErrorMessage(error)));
		} else {
			getPortalUserRoles()
				.then((roleResponse) => {
					this.roleOptions = roleResponse.roles;
					this.updateRoles();
				})
				.catch((error) => toastErrorMessage(parseErrorMessage(error)));
		}

		if (this.pageMode === "view") {
			this.disableGridCheckboxes = true;
			this.canEditRoles = false;
		}
		getSponsors()
			.then((sponsorResponse) => {
				this.sponsorOptions = sponsorResponse;
				// preset sponsor id if there is only one option to chose from
				if (
					this.pageMode === "add" &&
					this.sponsorOptions.length === 1
				) {
					this.userSponsorIds = [
						parseInt(this.sponsorOptions[0].value),
					];
					this.showSponsors = false;
				}
			})
			.catch((error) => toastErrorMessage(parseErrorMessage(error)));
	}

	noRole() {
		this.disableGridCheckboxes = true;
		this.applyRolesToEntities = [];
		this.showSponsors = false;
		this.userSponsorIds = [];
	}

	singleRole() {
		const mainRole = this.roleOption(this.userRoleIds[0]);
		if (mainRole) {
			if (this.roles.includes("EMP_ADMIN")) {
				if (mainRole.hierarchySelectedForEmployer) {
					const applyRolesToEntities: string[] = [];
					forEach(this.employerHierarchy, (parentOrg) => {
						applyRolesToEntities.push(parentOrg.id);
					});
					this.applyRolesToEntities = [...applyRolesToEntities];
				}
				this.disableGridCheckboxes =
					!mainRole.hierarchyEnabledForEmployer;
			} else {
				if (mainRole.hierarchySelected) {
					const applyRolesToEntities: string[] = [];
					forEach(this.employerHierarchy, (parentOrg) => {
						applyRolesToEntities.push(parentOrg.id);
					});
					this.applyRolesToEntities = [...applyRolesToEntities];
				}
				this.disableGridCheckboxes = !mainRole.hierarchyEnabled;
			}
			this.showSponsors = mainRole.showSponsors;
		}
	}

	async onClickSave() {
		if (await (this.$refs.userDetailsForm as VForm).validate()) {
			if (this.userRoleIds.length === 0) {
				if (this.applyRolesToEntities.length === 0) {
					toastErrorMessage(
						"Please select at least one role and at least one entity from the hierarchy table."
					);
				} else {
					toastErrorMessage("Please select at least one role.");
				}
				return;
			}
			if (this.applyRolesToEntities.length === 0) {
				toastErrorMessage(
					"Please select at least one entity from the hierarchy table."
				);
				return;
			}

			//Sponsor ID is required for roles with showSponsors=true (Sponsor, Sponsor Operations)
			if (this.userRoleIds.length === 1) {
				const selectedRole = this.roleOption(this.userRoleIds[0]);
				if (
					selectedRole &&
					selectedRole.showSponsors &&
					this.userSponsorIds.length === 0
				) {
					toastErrorMessage("Please select at least one sponsor.");
					return;
				}
			}

			//check if any roles have orphan parent names on them
			const entities: string[] = [];
			forEach(this.applyRolesToEntities, (roleId) => {
				if (roleId.startsWith(noParentEmployerPrefix)) {
					entities.push(roleId.split(noParentEmployerPrefix)[1]);
				} else {
					entities.push(roleId);
				}
			});

			let method: "post" | "POST" | "put" | "PUT" = "POST";
			let url: string | null = null;
			if (this.pageMode === "add") {
				method = "POST";
				url = `/api/users/add`;
			} else {
				method = "PUT";
				url = `/api/users/${this.$route.params.userId}`;
			}
			if (url && method) {
				axios
					.request<void>({
						method: method,
						url: url,
						data: {
							user: this.userDetail,
							entities: entities,
							roleIds: this.userRoleIds,
							sponsorIds: this.userSponsorIds,
						},
						headers: {
							"Content-Type": "application/json",
						},
					})
					.then((resp) => {
						if (this.pageMode === "add") {
							toastSuccessMessage(
								`Create new user with name ${this.userDetail?.name} was successful`
							);
						} else {
							toastSuccessMessage(
								`Edit user ${this.userDetail?.name} was successful`
							);
						}

						this.isFormDirty = false;
						this.$router.push({ name: "Users and roles" });
					})
					.catch((e) => {
						toastErrorMessage(parseErrorMessage(e));
					});
			}
		} else {
			toastErrorMessage("Fields highlighted above have errors.");
		}
	}
	onCancel() {
		if (this.isFormDirty) {
			this.showCancelModal = true;
		} else {
			this.discardChanges();
		}
	}

	discardChanges() {
		this.isFormDirty = false;
		this.$router.push({ name: "Users and roles" });
	}

	buildHierarchiesToAccess() {
		const hierarchiesToAccess: HierarchiesToAccess[] = [];
		forEach(this.employerHierarchy, (parentOrg) => {
			// orphan employer
			if (parentOrg.id.startsWith(EMPLOYER)) {
				const employer = {
					employerId: parentOrg.id,
					employerLabel: parentOrg.label,
					parentId: noParentEmployerPrefix + parentOrg.id,
					parentLabel: "N/A",
				};

				forEach(parentOrg.children, (rc) => {
					if (
						!this.parentChildRelationship[
							noParentEmployerPrefix + parentOrg.id
						]
					) {
						this.parentChildRelationship[
							noParentEmployerPrefix + parentOrg.id
						] = [];
					}
					this.parentChildRelationship[
						noParentEmployerPrefix + parentOrg.id
					].push(rc.id);
					this.childParentRelationship[rc.id] = parentOrg.id;
					const reportingCentre = {
						rcId: rc.id,
						rcLabel: rc.label,
					};
					hierarchiesToAccess.push({
						...employer,
						...reportingCentre,
					});
				});
			} else {
				this.orphanParent = false;
				const parent = {
					parentId: parentOrg.id,
					parentLabel: parentOrg.label,
				};

				if (!parentOrg.children || parentOrg.children.length <= 0) {
					hierarchiesToAccess.push({ ...parent });
				}

				forEach(parentOrg.children, (emplyr) => {
					const employer = {
						employerId: emplyr.id,
						employerLabel: emplyr.label,
					};

					if (!this.parentChildRelationship[parentOrg.id]) {
						this.parentChildRelationship[parentOrg.id] = [];
					}
					this.childParentRelationship[emplyr.id] = parentOrg.id;
					this.parentChildRelationship[parentOrg.id].push(emplyr.id);
					if (!emplyr.children || emplyr.children.length <= 0) {
						hierarchiesToAccess.push({
							...parent,
							...employer,
							rcId: undefined,
							rcLabel: "N/A",
						});
					}

					forEach(emplyr.children, (rc) => {
						if (!this.parentChildRelationship[emplyr.id]) {
							this.parentChildRelationship[emplyr.id] = [];
						}
						this.childParentRelationship[rc.id] = emplyr.id;
						this.parentChildRelationship[emplyr.id].push(rc.id);
						const reportingCentre = {
							rcId: rc.id,
							rcLabel: rc.label,
						};
						hierarchiesToAccess.push({
							...parent,
							...employer,
							...reportingCentre,
						});
					});
				});
			}
		});
		// NOTE that hierarchiesToAccess is never changed after this initialisation.
		this.hierarchiesToAccess = hierarchiesToAccess;
	}

	async beforeMount() {
		axios
			.get<BrandList>(currentBrandsListURL())
			.then((response) => {
				this.brandOptions = response.data.brands.map(
					(brand: BrandOption) => ({
						label: brand.label,
						value: brand.value.toString(),
					})
				);
			})
			.catch((error) => toastErrorMessage(parseErrorMessage(error)));
	}

	async beforeRouteEnter(
		to: AppRoute,
		_from: AppRoute,
		next: AppRouteNextFunction<AddOrEditPortalUsers>
	) {
		const mode: PageMode = getModeFromPath(to.path);
		if (mode === "view" || mode === "edit") {
			const userId = Number(to.params.userId);
			const userResponse = await getPortalUser(userId);
			if (userResponse === undefined) {
				next(new Error(`Unable to fetch user [id=${userId}].`));
				return;
			}
			if (mode === "edit" && userResponse.user.ownRecord) {
				const error = `Unable to edit current login user.`;
				toastErrorMessage(error);
				next(new Error(error));
				return;
			}

			if (
				mode === "edit" &&
				!hasEditPermissionOnUser(userResponse.user)
			) {
				const error = `Unable to edit sponsor or domain user.`;
				toastErrorMessage(error);
				next(new Error(error));
				return;
			}
		}
		next();
	}

	private onClickCheckBox({
		rowIndex,
		row,
		value,
		groupBy,
	}: {
		rowIndex: number;
		row: HierarchiesToAccess;
		value: boolean;
		groupBy: string;
	}): void {
		//employer
		if (groupBy === EMPLOYER) {
			this.addOrRemoveEntity(row, "employerId", value);
		} // parent
		else if (groupBy === PARENT) {
			this.addOrRemoveEntity(row, "parentId", value);
		} // rc
		else if (groupBy === RC) {
			this.addOrRemoveEntity(row, "rcId", value);
		}

		this.isFormDirty = true;
	}

	beforeRouteLeave(
		to: AppRoute,
		from: AppRoute,
		next: AppRouteNextFunction<AddOrEditPortalUsers>
	) {
		if (this.isFormDirty) {
			this.showCancelModal = true;
			next(false);
		} else {
			next();
		}
	}
}
